export default __webpack_public_path__ + "media/flags/lt-b40a2987.svg";